export default __webpack_public_path__ + "static/media/APACHE_KAFKA.5366f4d5.png";